import ToastEventBus from 'primevue/toasteventbus';

/**
 * Thin wrapper around PrimeVue's `ToastEventBus`, used so toast notifications
 * can be triggered from anywhere (including outside components) without
 * needing access to the `useToast()` composable.
 */
const toast = {
  /** Emits an 'add' event to show a new toast with the given message options. */
  add: (message) => ToastEventBus.emit('add', message),
  /** Emits a 'remove-group' event to dismiss all toasts belonging to the given group. */
  removeGroup: (group) => ToastEventBus.emit('remove-group', group),
  /** Emits a 'remove-all-groups' event to dismiss every currently displayed toast. */
  removeAllGroups: () => ToastEventBus.emit('remove-all-groups'),
};

/**
 * Displays a toast notification via PrimeVue's toast service.
 * @param {'success'|'info'|'warn'|'error'|'secondary'|'contrast'} [severity='info'] visual style/severity of the toast
 * @param {string|null} [summary=null] short bold title text
 * @param {string|null} [detail=null] longer descriptive message body
 * @param {number|null} [life=null] time in milliseconds before the toast auto-dismisses (null = stays until closed)
 * @param {boolean} [closable=true] whether the toast shows a manual close button
 * @param {string|null} [group=null] named group used to target this toast with `removeGroup`
 * @param {string|null} [styleClass=null] extra CSS class applied to the toast container
 * @param {string|null} [contentStyleClass=null] extra CSS class applied to the toast content
 * @param {*} [data=null] arbitrary data passed through to custom toast templates
 */
export const showNotification = (
  severity = 'info',
  summary = null,
  detail = null,
  life = null,
  closable = true,
  group = null,
  styleClass = null,
  contentStyleClass = null,
  data = null
) => {
  toast.add({
    severity: severity,
    summary: summary,
    detail:  detail,
    life: life,
    closable: closable,
    group: group,
    styleClass: styleClass,
    contentStyleClass: contentStyleClass,
    data: data
  });
}
